import { Divider, Table } from 'antd'
import API from 'API'
import FullMask from 'components/layout/FullMask'
import React, { useEffect, useState } from 'react'

const models = [
    {name: "Gemini 2.0 Flash", input: 0.1, output: 0.4},
    {name: "GPT-4o mini", input: 0.15, output: 0.6},
    {name: "GPT-4o", input: 2.5, output: 10},
]

function calc(input, output, model) {
    const m = models.find(item => item.name === model)
    const result = +m.input*input/1000000 + +m.output*output/1000000
    return `${result}$ | ${Math.round(result*27000)}đ`
}

export default function APToken() {
    const [AITokens, setAITokens] = useState(null)
    const [loading, setLoading] = useState(true)
    useEffect(()=>{
        API.get("admin-api/aitoken/")
        .then(res=>{
            setAITokens(res.data)
        })
        .catch(error=>console.log(error))
        .finally(()=>{
            setLoading(false)
        })
    },[])
    return loading ? <FullMask /> : <>
        <Table rowKey="name" columns={[
            {key: "name", dataIndex: "name", title: "Model"},
            {key: "input", dataIndex: "input", title: "Input price ($/1M)"},
            {key: "output", dataIndex: "output", title: "Output price ($/1M)"},
        ]}
            dataSource={models}
        />
        <Divider />
        <Table rowKey="id" columns={[
            {key: "name", dataIndex: "name", title: "Name"},
            {key: "input_token", dataIndex: "input_token", title: "Input Token"},
            {key: "output_token", dataIndex: "output_token", title: "Ouput Token"},
            {key: "gemini", dataIndex: "gemini", title: "Gemini 2.0 Flash"},
            {key: "gptMini", dataIndex: "gptMini", title: "GPT-4o mini"},
            {key: "gpt", dataIndex: "gpt", title: "GPT-4o"},
        ]}  dataSource={AITokens.map(item=>({
            ...item,
            gemini: calc(item.input_token,item.output_token,"Gemini 2.0 Flash"),
            gptMini: calc(item.input_token,item.output_token,"GPT-4o mini"),
            gpt: calc(item.input_token,item.output_token,"GPT-4o"),
        }))}
        />
    </>
}
